import React, { useEffect, useState } from 'react';
const LIPSCORE_API_KEY = globalThis.lipscoreApiKey;
const LIPSCORE_LOCALE = globalThis.lipscoreLocale;
const STAR_AMOUNT = 5;

const fetchRating = () => {
  const url = `https://wapi.lipscore.com/initial_data/products/show?api_key=${LIPSCORE_API_KEY}&internal_id=service_review&widgets=srw_t&translate_to_lang=${LIPSCORE_LOCALE}`;
  return fetch(url).then((res) => res.json());
};

const Star = ({ starState }) => (
  <svg
    viewBox="0 0 19 18.1"
    className={`lipscore-rating-star lipscore-svg-rating-star ${
      starState
        ? `lipscore-star-${starState} lipscore-rating-star-${starState}`
        : ''
    }`}
    width="20px"
    height="20px"
    style={{ fillRule: 'evenodd', fill: '#251e19' }}
  >
    <g transform="matrix(0.896868,0,0,0.983811,-0.279534,0)">
      <path d="M11.573,1.193L11.573,15.61L10.916,15.3L4.362,18.388L5.558,11.752L0.312,7.024L7.605,6.01L10.916,0L11.573,1.193Z"></path>
    </g>
    <g
      className="lipscore-star-last-half"
      transform="matrix(1,0,0,1,-133.489,-464)"
    >
      <path d="M142.989,464.021L143,464L145.97,469.912L152.511,470.91L147.805,475.561L148.878,482.09L143,479.052L142.989,479.058L142.989,464.021Z"></path>
    </g>
  </svg>
);

const HeaderServiceRating = () => {
  const [rating, setRating] = useState();

  const formatRating = (rating) => {
    if (!rating.lipscore) {
      return;
    }

    const diviser = 2;
    const ratingInt = parseFloat(rating.lipscore);
    const roundedRatingInt = Math.round(ratingInt * 10) / 10;
    const formattedRating = Math.round((roundedRatingInt / diviser) * 10) / 10;

    setRating(formattedRating);
  };

  useEffect(() => {
    if (!LIPSCORE_API_KEY && !LIPSCORE_LOCALE) {
      return;
    }

    fetchRating()
      .then((rating) => formatRating(rating))
      .catch((err) => console.log(err));
  }, []);

  const getStarState = (index) => {
    if (typeof rating === 'undefined') return undefined;

    const diff = rating - index;
    if (diff > 0 && diff < 1) {
      return 'incomplete';
    } else if (diff <= 0) {
      return 'inactive';
    }
    return undefined;
  };

  return rating ? (
    <>
      <div className="lipscore-service-reviews__score">{rating}</div>
      <div className="lipscore-service-reviews__stars-and-amount">
        <div className="lipscore-service-reviews__stars">
          {Array.from({ length: STAR_AMOUNT }).map((_, idx) => (
            <Star starState={getStarState(idx)} key={`lipscore-stars-${idx}`} />
          ))}
        </div>
      </div>
    </>
  ) : null;
};

export default HeaderServiceRating;
